import b_ from 'b_';
import {useUnit} from 'effector-react';
import React from 'react';

import {TaxiFormLayoutRow} from '#components2/support/taxi-form-layout';
import {$configsError} from 'models';
import i18n from 'utils/localization/i18n';

import './warning.styl';

const taxiStyle = b_.with('Warning');

export const ConfigsLoadingError = React.memo(function () {
    const [configsError] = useUnit([$configsError]);

    if (!configsError) {
        return null;
    }

    return (
        <TaxiFormLayoutRow gap="no">
            <div className={taxiStyle()}>{`${i18n.print('warning.configs_loading_error')}: ${configsError}`}</div>
        </TaxiFormLayoutRow>
    );
});
